module.exports = __webpack_public_path__ + "img/location-w.svg";